import { Link } from 'react-router-dom';

export function ModuleHeader({ title, subtitle, backTo }: { title: string; subtitle?: string; backTo?: string }) {
  return <header className="module-header"><div className="module-header__row">
    {backTo && <Link className="module-header__back" to={backTo} aria-label="Înapoi">‹</Link>}
    <div><span className="eyebrow">Nova Prompt</span><h1>{title}</h1>{subtitle && <p>{subtitle}</p>}</div>
    <Link className="module-switch" to="/modules">Acasă</Link>
  </div></header>;
}
